import { TableResponse } from '@/types';
import { LawyerContractList } from '../types/LawyerContractList';
import { axios2 } from '@/lib/axios';
import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';
import { useQuery } from 'react-query';

export const getLawyerRequests = (): Promise<TableResponse<LawyerContractList>> => {
  // return axios2.get('/lawyer-api/user-contract-request');
  return axios2.get('/lawyer-api/lawyer-property-request');
};

type QueryFnType = typeof getLawyerRequests;

type UseInquiryOptions = {
  config?: QueryConfig<QueryFnType>;
};

export const useLawyerRequests = ({ config }: UseInquiryOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['agency-req'],
    queryFn: () => getLawyerRequests(),
  });
};
